export default __webpack_public_path__ + "static/media/rejected-status.06a077b8.svg";